<template>
    <el-collapse v-model="activeNames">
        <el-collapse-item
            v-for="(d,key) in groupedData"
            :title="d[0].location.parent.parent.name"
            :name="d[0].location.parent.parent.id"
            :key="key"
            :id="'OfficeCard'+key"
            v-scroll-to="'#OfficeCard'+key"
        >
            <office-card v-for="d2 in d" :data="d2" :key="d2.id"></office-card>
        </el-collapse-item>
    </el-collapse>
</template>
<style lang="scss">
    .el-collapse {
        border: 0;
    }
    .el-collapse-item__wrap {
        background-color: transparent;
    }
    .el-collapse-item__content {
        padding: 0;
    }
</style>
<script>
    import ElCollapse from 'element-ui/lib/collapse';
    import ElCollapseItem from 'element-ui/lib/collapse-item';
    import OfficeCard from './OfficeCard.vue';

    var options = {
        container: '#container',
        easing: 'ease-in',
        offset: -60,
        force: true,
        cancelable: true,
        onStart: function(element) {
          // scrolling started
        },
        onDone: function(element) {
          // scrolling is done
        },
        onCancel: function() {
          // scrolling has been interrupted
        },
        x: false,
        y: true
    }

    export default {
        components: {
            ElCollapse,
            ElCollapseItem,
            OfficeCard
        },
        mounted: function(){
            VueScrollTo.scrollTo('#OfficeCardPattern');
        },
        data() {
            return {
                activeNames: []
            };
        },
        props: ['data'],
        computed:{
            groupedData: function(){
                return _(this.data)
                    .groupBy(function(d){
                        return d.location.parent.parent.id;
                    })
                    .values()
                    .orderBy(function(d){
                        return d[0].location.parent.parent.lat;
                    }, 'desc')
                    .value();
            }
        }
    }
</script>